<template>
  <div>Healthy</div>
</template>

<script>
export default {
  name: "health",
  data(){
    return  {

    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>